import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import sideBar6 from "../assets/utils/images/sidebar/city1.jpg";

export interface ThemeOptionsState {
  backgroundColor: string;
  headerBackgroundColor: string;
  enableMobileMenuSmall: string;
  enableBackgroundImage: boolean;
  enableClosedSidebar: boolean;
  enableFixedHeader: boolean;
  enableHeaderShadow: boolean;
  enableSidebarShadow: boolean;
  enableFixedFooter: boolean;
  enableFixedSidebar: boolean;
  enableMobileMenu?: boolean;
  colorScheme: string;
  backgroundImage: string;
  backgroundImageOpacity: string;
  enablePageTitleIcon: boolean;
  enablePageTitleSubheading: boolean;
  enablePageTabsAlt: boolean;
}

const initialState: ThemeOptionsState = {
  backgroundColor: "",
  headerBackgroundColor: "",
  enableMobileMenuSmall: "",
  enableBackgroundImage: false,
  enableClosedSidebar: false,
  enableFixedHeader: true,
  enableHeaderShadow: true,
  enableSidebarShadow: true,
  enableFixedFooter: true,
  enableFixedSidebar: true,
  colorScheme: "white",
  backgroundImage: sideBar6,
  backgroundImageOpacity: "opacity-06",
  enablePageTitleIcon: true,
  enablePageTitleSubheading: true,
  enablePageTabsAlt: true,
};

const themeOptionsSlice = createSlice({
  name: "ThemeOptions",
  initialState,
  reducers: {
    setEnableBackgroundImage(state, action: PayloadAction<boolean>) {
      state.enableBackgroundImage = action.payload;
    },
    setEnableFixedHeader(state, action: PayloadAction<boolean>) {
      state.enableFixedHeader = action.payload;
    },
    setEnableHeaderShadow(state, action: PayloadAction<boolean>) {
      state.enableHeaderShadow = action.payload;
    },
    setEnableSidebarShadow(state, action: PayloadAction<boolean>) {
      state.enableSidebarShadow = action.payload;
    },
    setEnablePageTitleIcon(state, action: PayloadAction<boolean>) {
      state.enablePageTitleIcon = action.payload;
    },
    setEnablePageTitleSubheading(state, action: PayloadAction<boolean>) {
      state.enablePageTitleSubheading = action.payload;
    },
    setEnablePageTabsAlt(state, action: PayloadAction<boolean>) {
      state.enablePageTabsAlt = action.payload;
    },
    setEnableFixedSidebar(state, action: PayloadAction<boolean>) {
      state.enableFixedSidebar = action.payload;
    },
    setEnableClosedSidebar(state, action: PayloadAction<boolean>) {
      state.enableClosedSidebar = action.payload;
    },
    setEnableMobileMenu(state, action: PayloadAction<boolean>) {
      state.enableMobileMenu = action.payload;
    },
    setEnableMobileMenuSmall(state, action: PayloadAction<string>) {
      state.enableMobileMenuSmall = action.payload;
    },
    setEnableFixedFooter(state, action: PayloadAction<boolean>) {
      state.enableFixedFooter = action.payload;
    },
    setBackgroundColor(state, action: PayloadAction<string>) {
      state.backgroundColor = action.payload;
    },
    setHeaderBackgroundColor(state, action: PayloadAction<string>) {
      state.headerBackgroundColor = action.payload;
    },
    setColorScheme(state, action: PayloadAction<string>) {
      state.colorScheme = action.payload;
    },
    setBackgroundImage(state, action: PayloadAction<string>) {
      state.backgroundImage = action.payload;
    },
    setBackgroundImageOpacity(state, action: PayloadAction<string>) {
      state.backgroundImageOpacity = action.payload;
    },
  },
});

export const {
  setEnableBackgroundImage,
  setEnableFixedHeader,
  setEnableHeaderShadow,
  setEnableSidebarShadow,
  setEnablePageTitleIcon,
  setEnablePageTitleSubheading,
  setEnablePageTabsAlt,
  setEnableFixedSidebar,
  setEnableClosedSidebar,
  setEnableMobileMenu,
  setEnableMobileMenuSmall,
  setEnableFixedFooter,
  setBackgroundColor,
  setHeaderBackgroundColor,
  setColorScheme,
  setBackgroundImage,
  setBackgroundImageOpacity,
} = themeOptionsSlice.actions;

export default themeOptionsSlice.reducer;
